import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { CourseStopEntity } from 'src/entities/Course.entity';

type Props = {
  stop: CourseStopEntity | null; courseCode: string;
  /** 開いている並びのダイヤ名。未所属の並びは null（コースの並びが 1 つだけなのでダイヤ名を出さない） */
  timetableName: string | null;
  onConfirm: () => void; onClose: () => void;
};

/** 適用終了（開いている並びだけ・今日から使わない。D21 決定 17 を log_web_issues#403 の 5 で見直し）。行は消えず履歴に残る */
export default function EndStopDialog({ stop, courseCode, timetableName, onConfirm, onClose }: Props) {
  return (
    <Dialog open={Boolean(stop)} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontSize: 16 }}>コースから削除しますか？</DialogTitle>
      <DialogContent sx={{ fontSize: 14 }}>
        {stop?.place.name} を {courseCode} コースの{timetableName != null && `「${timetableName}」の`}配送順から外します。閉店・配送終了などで今後配送しない場合に使います。
        <Box sx={{ mt: 1, color: 'text.secondary', fontSize: 13 }}>
          行は「適用終了」として履歴に残り、解除できます。
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>キャンセル</Button>
        <Button color="error" variant="contained" disableElevation onClick={onConfirm}>コースから削除</Button>
      </DialogActions>
    </Dialog>
  );
}
